import { Box } from "@mui/material";
// eslint-disable-next-line no-restricted-imports
import { type Location } from "@src/utils/routes";
import { startTransition } from "react";
import { useHistory } from "react-router-dom";

import { Icon, type IconType } from "../../components/Icon";
import { Text } from "../../components/Text";
import { applyPlatformAwareInteractionStyles } from "../../utils/applyPlatformAwareInteractionStyles";

interface NavigationMenuItemProps {
  children: React.ReactNode;
  iconType: IconType;
  isSelected: boolean;
  routeTo?: Location;
  onClick?: () => void;
}

export function NavigationMenuItem(props: NavigationMenuItemProps) {
  const { children, iconType, isSelected, routeTo, onClick } = props;

  const history = useHistory();

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: 3,
        gap: 3,
        borderRadius: theme.borderRadius?.medium,
        cursor: "pointer",
        transition: theme.transitions.create(["background-color"], {
          duration: theme.transitions.duration.short,
        }),

        color: isSelected
          ? theme.palette.navbar?.itemContentSelected
          : theme.palette.navbar?.itemContent,

        backgroundColor: isSelected ? theme.palette.navbar?.itemSelectedBackground : "transparent",

        ...applyPlatformAwareInteractionStyles({
          hoverStyle: {
            backgroundColor: theme.palette.navbar?.itemSelectedBackground,
            color: theme.palette.navbar?.itemContentSelected,
          },

          defaultStyle: {
            backgroundColor: isSelected
              ? theme.palette.navbar?.itemSelectedBackground
              : "transparent",

            color: isSelected
              ? theme.palette.navbar?.itemContentSelected
              : theme.palette.navbar?.itemContent,
          },
        }),
      })}
      onClick={() => {
        if (routeTo) {
          startTransition(() => {
            history.push(routeTo);
          });
        }

        onClick?.();
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Icon
          type={iconType}
          size="large"
          sx={{
            color: "inherit",
            flexShrink: 0,
          }}
        />

        <Text
          bold
          variant="body1"
          sx={{
            color: "inherit",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            lineHeight: 1,
          }}
        >
          {children}
        </Text>
      </Box>
    </Box>
  );
}
